// eslint-disable-next-line import/no-restricted-paths
import { infoNotification } from "../../../components/app/Notifications/notifications";
import { MIN_RECOMMENDED_WIDTH, MAX_RECOMMENDED_WIDTH } from "./screenResolutionConsts";

const SCREEN_SIZE_PROMPT_AUTO_CLOSE_SECONDS = 20;

/**
 * Prompts user to zoom in or out with unusually large or small screens
 * */
export function promptZoomForUncommonScreenSizes(screenWidth) {
    if (!screenWidth || (screenWidth >= MIN_RECOMMENDED_WIDTH && screenWidth <= MAX_RECOMMENDED_WIDTH)) return;
    const zoomDirection = screenWidth < MIN_RECOMMENDED_WIDTH ? "out" : "in";
    infoNotification(
        {
            title: "Uncommon screen resolution detected",
            text: `For an optimal experience on your screen, we suggest zooming ${zoomDirection} using your browser.`,
        },
        SCREEN_SIZE_PROMPT_AUTO_CLOSE_SECONDS,
    );
}
